import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
// import { useAuth0 } from "@auth0/auth0-react";
import { getDiary } from "../api.js";
import { Breadcrumb, Loading, Diary } from "../components";

export function DiaryDetailPage() {
  const [diary, setDiary] = useState(null);
  // const { getAccessTokenWithPopup } = useAuth0();

  const params = useParams();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const perPage = 5;
  const page = +query.get("page") || 1;

  useEffect(() => {
    getDiary(params.diaryId, {
      limit: perPage,
      offset: (page - 1) * perPage,
    }).then((data) => {
      setDiary(data);
    });
  }, [params.diaryId, page]);

  return (
    <>
      <div className="box">
        <Breadcrumb
          links={[
            { href: "/", content: "Top" },
            { href: "/diaries", content: "一覧" },
            {
              href: `/diaries/${params.diaryId}`,
              content: diary && `${diary.title} の情報`,
              active: true,
            },
          ]}
        />
      </div>
      {diary == null ? (
        <Loading />
      ) : (
        <>
          <div className="block">
              <Diary key={diary.id} diary={diary} />
          </div>
        </>
      )}
    </>
  );
}